export { default } from './Faq.container';
